module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav-small-disabled.09913e89.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/PrevSliderButton/images/prev-nav-small-disabled.png
// module id = 3156
// module chunks = 11